import { Box, Button, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { ExternalLinkIcon } from "../../../../../../components/Icons";
import { EOrderStatus, IMappedOrder } from "../../../../../../services/orders/orders.interface";
import OrderStatus from "../OrderStatus/OrderStatus";
import OrderItem from "./OrderItem/OrderItem";
import { VETCOVE_URL } from "../../../../../../config/params";
import { useVetCoveRedirect } from "../../../../../../hooks/useVetCoveRedirect";

interface IOrderCardProps {
  order: IMappedOrder;
  shopUrl: string;
}

const OrderCard = ({ order, shopUrl }: IOrderCardProps) => {
  const { id, orderNumber, status, date, items, total, vetCoveUrl } = order;
  const { handleVetCoveLink } = useVetCoveRedirect();

  const showBuyAgain = [EOrderStatus.COMPLETED, EOrderStatus.CANCELED, EOrderStatus.PAYMENT_FAILED].includes(status);

  const handleViewInPharmacy = useCallback(() => {
    handleVetCoveLink(vetCoveUrl, shopUrl || VETCOVE_URL);
  }, [vetCoveUrl, shopUrl, handleVetCoveLink]);

  return (
    <Box
      className="bg-white rounded-lg border overflow-hidden p-6"
      sx={{ borderColor: "neutral.main", boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.04)" }}
    >
      <Box className="flex flex-col py-2 gap-2">
        <Box className="flex align-center gap-3">
          <Typography fontSize={16} className="flex items-center">
            Order {orderNumber}
          </Typography>
          <OrderStatus status={status} />
        </Box>
        <Box className="flex items-center gap-4 text-sm">
          <Typography>{date}</Typography>
          <Typography>•</Typography>
          <Typography>{items.length} items</Typography>
          <Typography>•</Typography>
          <Typography>${total} (total with taxes included)</Typography>
        </Box>
      </Box>

      <Box className="flex flex-col border-t border-b py-4 gap-2" sx={{ borderColor: "neutral.main" }}>
        {order.items.map((item, i) => (
          <OrderItem key={`${item.id}-${i}`} item={item} showBuyAgain={showBuyAgain} />
        ))}
      </Box>

      <Box className="flex justify-between items-center">
        <Typography variant="body2">Order ID: {id}</Typography>
        <Button variant="text" startIcon={<ExternalLinkIcon width={16} height={16} />} onClick={handleViewInPharmacy}>
          View in Online Pharmacy
        </Button>
      </Box>
    </Box>
  );
};

export default OrderCard;
